(function () {
  'use strict';

  if (window.__rccAlgoliaTrackingLoaded) return;
  window.__rccAlgoliaTrackingLoaded = true;

  var EVENT_URL = 'https://storefront.retailconnect.app/v1/event';
  var PROJECT_NAME = 'retail-catalog-new-website';
  var ALGOLIA_HOST = /(?:algolianet\.com|algolia\.net)$/i;
  var DEBUG = false;
  var visitorId = getVisitorId();
  var sentEvents = window.__rccAlgoliaSentEvents = window.__rccAlgoliaSentEvents || {};

  if (DEBUG) console.info('[RCC] Algolia tracking ready', { projectName: PROJECT_NAME, visitorId: visitorId });

  function getVisitorId() {
    var match = document.cookie.match(/(?:^|;\s*)rcc-visitor-id=([^;]+)/);
    if (match) return decodeURIComponent(match[1]);

    var id = window.crypto && crypto.randomUUID
      ? crypto.randomUUID()
      : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (character) {
          var random = Math.random() * 16 | 0;
          return (character === 'x' ? random : random & 3 | 8).toString(16);
        });

    document.cookie = 'rcc-visitor-id=' + encodeURIComponent(id) + '; Max-Age=31536000; Path=/; SameSite=Lax; Secure';
    return id;
  }

  function isAlgolia(url) {
    try {
      return ALGOLIA_HOST.test(new URL(url, location.origin).hostname);
    } catch (error) {
      return false;
    }
  }

  function parseJson(value) {
    if (!value) return null;
    if (typeof value !== 'string') return value;
    try {
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  }

  function parseParams(params) {
    if (!params) return {};
    if (typeof params !== 'string') return params;

    var parsed = {};
    new URLSearchParams(params).forEach(function (value, key) {
      parsed[key] = value;
    });
    return parsed;
  }

  function isDisplayedResults(params) {
    return String(params.distinct) !== 'false' &&
      Number(params.hitsPerPage) > 0;
  }

  function isCollectionPage() {
    return window.theme && theme.template && theme.template.name === 'collection';
  }

  function getProductIds(result) {
    return result.hits.reduce(function (ids, hit) {
      var id = hit && hit.id;
      if (id != null && ids.indexOf(String(id)) === -1) ids.push(String(id));
      return ids;
    }, []);
  }

  function postEvent(payload, eventKey) {
    if (sentEvents[eventKey]) return;
    sentEvents[eventKey] = true;

    if (DEBUG) console.info('[RCC] Sending Algolia event', payload);

    // Single reliable path: keepalive fetch survives page unload (like a beacon)
    // but, unlike sendBeacon, reports the real server response so failures are visible.
    fetch(EVENT_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true
    }).then(function (response) {
      if (response.ok) {
        if (DEBUG) console.info('[RCC] Event accepted:', response.status);
      } else {
        console.warn('[RCC] Event rejected:', response.status);
      }
    }).catch(function (error) {
      console.warn('[RCC] Event failed:', error);
    });
  }

  function sendEvent(params, result) {
    if (DEBUG && result && Array.isArray(result.hits)) {
      console.info('[RCC] Algolia results observed', {
        query: String(params.query || result.query || ''),
        page: params.page,
        hitsPerPage: params.hitsPerPage,
        distinct: params.distinct,
        clickAnalytics: params.clickAnalytics,
        hits: result.hits.length,
        willSend: isDisplayedResults(params)
      });
    }

    if (!isDisplayedResults(params) || !result || !Array.isArray(result.hits)) return;

    var productIds = getProductIds(result);
    if (!productIds.length) return;

    var collectionId = isCollectionPage() && window.algoliaShopify && algoliaShopify.current_collection_id;
    var searchQuery = String(params.query || result.query || '');
    if (!searchQuery && !collectionId) return;

    var page = Number(params.page || 0);
    var hitsPerPage = Number(params.hitsPerPage || productIds.length);
    if (!Number.isFinite(page)) page = 0;
    if (!Number.isFinite(hitsPerPage) || hitsPerPage < 1) hitsPerPage = productIds.length;

    var userInfo = { userAgent: navigator.userAgent };
    if (window.theme && theme.customer && theme.customer.id) userInfo.userId = String(theme.customer.id);

    var userEvent = {
      eventType: 'search',
      visitorId: visitorId,
      searchQuery: searchQuery,
      offset: page * hitsPerPage,
      productDetails: productIds.map(function (id) {
        return { product: { id: id } };
      }),
      userInfo: userInfo,
      experimentIds: ['CONTROL']
    };

    if (collectionId) {
      collectionId = String(collectionId);
      userEvent.filter = [{ field: 'attributes.rcc_collection_id', value: [collectionId] }];
      userEvent.pageCategories = [collectionId];
    }

    postEvent(
      { projectName: PROJECT_NAME, userEvent: userEvent },
      [collectionId || '', searchQuery, userEvent.offset, productIds.join(',')].join('|')
    );
  }

  function track(requestBody, responseBody) {
    var request = parseJson(requestBody);
    var response = parseJson(responseBody);
    if (!request || !response) return;

    var requests = request.requests || [request];
    var results = response.results || [response];
    requests.forEach(function (item, index) {
      sendEvent(parseParams(item.params || item), results[index]);
    });
  }

  var originalFetch = window.fetch;
  if (originalFetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : input && input.url;
      if (!isAlgolia(url)) return originalFetch.apply(this, arguments);

      var body = init && init.body;
      if (!body && input && typeof input.clone === 'function') body = input.clone().text();
      var responsePromise = originalFetch.apply(this, arguments);

      responsePromise.then(function (response) {
        Promise.all([body, response.clone().json()]).then(function (values) {
          track(values[0], values[1]);
        }).catch(function () {});
      });
      return responsePromise;
    };
  }

  function installXhrTracking() {
    var originalOpen = XMLHttpRequest.prototype.open;
    var originalSend = XMLHttpRequest.prototype.send;

    if (!originalOpen.__rccAlgoliaTracking) {
      XMLHttpRequest.prototype.open = function (method, url) {
        this.__rccAlgolia = isAlgolia(url);
        return originalOpen.apply(this, arguments);
      };
      XMLHttpRequest.prototype.open.__rccAlgoliaTracking = true;
    }

    if (!originalSend.__rccAlgoliaTracking) {
      XMLHttpRequest.prototype.send = function (body) {
        if (this.__rccAlgolia) {
          this.addEventListener('load', function () {
            track(body, this.responseType === 'json' ? this.response : this.responseText);
          });
        }
        return originalSend.apply(this, arguments);
      };
      XMLHttpRequest.prototype.send.__rccAlgoliaTracking = true;
    }
  }

  installXhrTracking();
  window.addEventListener('load', installXhrTracking);

  if (new URLSearchParams(location.search).has('rcc-debug')) {
    console.assert(isDisplayedResults(parseParams('hitsPerPage=12&page=1&distinct=true')));
    console.assert(!isDisplayedResults(parseParams('hitsPerPage=1000&page=0&distinct=false')));
  }
})();
